'use strict';
angular
    .module('dnapp')
    .controller('DNDepartments.SocialShareController', [function () {
        this.socialShare = function (type, text, shareUrl) {
            var url = "";
            var width = 0;
            var height = 0;

            if (type === 'Twitter') {
                url = "https://twitter.com/intent/tweet?text=";
                width = 500;
                height = 280;

                url += text + " " + shareUrl;
            }
            if (type === 'Facebook') {
                url = "http://www.facebook.com/sharer/sharer.php?u=";
                width = 500;
                height = 350;

                url += shareUrl;
            }
            if (type === 'Bookmark') {
                bookmark();
                return;
            }
            if (type === 'LinkedIn') {
                url = "https://www.linkedin.com/shareArticle?mini=true&url=";

                width = 500;
                height = 280;

                url += shareUrl + "&title=" + text;
            }
            if (type === 'GooglePlus') {
                url = "https://plus.google.com/share?url=";

                width = 500;
                height = 350;

                url += shareUrl;
            }
            if (type === "MailTo") {
                mailTo(text, shareUrl);
                return;
            }
            if (type === "Print") {
                print();
                return;
            }

            window.open(url, type, "status = 1, height = " + height + ", width = " + width + ", resizable = 0");
        }

        function print() {
            window.print();
        }

        function mailTo(text, url) {
            window.location.href = "mailto:?subject=Fra Danmarks Naturfredningsforening: " + text + "&body=" + url;
        }

        function bookmark() {
            var bookmarkURL = window.location.href;
            var bookmarkTitle = document.title;

            if ('addToHomescreen' in window && window.addToHomescreen.isCompatible) {
                // Mobile browsers
                addToHomescreen({ autostart: false, startDelay: 0 }).show(true);
            } else if (window.sidebar && window.sidebar.addPanel) {
                // Firefox version < 23
                window.sidebar.addPanel(bookmarkTitle, bookmarkURL, '');
            } else if ((window.sidebar && /Firefox/i.test(navigator.userAgent)) || (window.opera && window.print)) {
                // Firefox version >= 23 and Opera Hotlist
                $(this).attr({
                    href: bookmarkURL,
                    title: bookmarkTitle,
                    rel: 'sidebar'
                }).off(e);
                return true;
            } else if (window.external && ('AddFavorite' in window.external)) {
                // IE Favorite
                window.external.AddFavorite(bookmarkURL, bookmarkTitle);
            } else {
                // Other browsers (mainly WebKit - Chrome/Safari)
                alert('Press ' + (/Mac/i.test(navigator.userAgent) ? 'Cmd' : 'Ctrl') + '+D to bookmark this page.');
            }

            return false;
        }
    }]);